<template>
  <!-- 新增实盘 -->
  <div class="all-l">
    <div class="Breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item class="is-l" :to="{ path: '/' }">实盘管理</el-breadcrumb-item>
        <el-breadcrumb-item>新增实盘</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="binding-bnt">
      <el-button @click="bindingClick">已绑定实盘</el-button>
    </div>
    <div class="total-list">
      <div class="total-list-mg">
        <div class="exchange-api">
          <div class="box-tittle">接入交易所API</div>
          <div class="box-body">
            <el-form :model="apiForm" :rules="rules" ref="ruleForm" label-width="" class="demo-ruleForm">
              <div style="display: flex; flex-direction: column">
                <div style="display: flex">
                  <div class="exchange-select">
                    <el-form-item label="➊ 选择交易所" prop="exchange" class="exchange-bnt" style="">
                      <el-radio-group v-model="apiForm.exchange" @change="exchangeChange">
                        <el-radio-button v-for="item in exchangeFrom" :key="item.id" :label="item">
                          <div class="im">
                            <img :src="
                                require(`../../assets/img/rtaLogo/${item.name}.svg`)
                              " alt="" />
                          </div>
                          {{ item.name }}
                        </el-radio-button>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                  <div class="fill-in-api">
                    <div class="set-up">
                      <span>➋ 填写API信息</span>
                      <a href="https://center.rta-finance.com/#/Course" target="_blank">
                        绑定API Key教程
                        <!-- <el-button
                          type="text"
                          class="course"
                          @click="courseClick"
                          >绑定API Key教程</el-button
                        > -->
                      </a>
                    </div>
                    <el-form-item label="API Key" prop="key">
                      <el-input v-model="apiForm.key" placeholder="请输入API Key"></el-input>
                    </el-form-item>
                    <el-form-item label="API Secret" prop="secret">
                      <el-input v-model="apiForm.secret" placeholder="请输入API Secret"></el-input>
                    </el-form-item>
                    <el-form-item label="passPhrase" prop="passPhrase" style="display: flex; flex-direction: column"
                      v-show="apiForm.exchange.name == 'okx'">
                      <el-input v-model="apiForm.passPhrase" placeholder="请输入passPhrase"></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div>
                  <el-form-item class="primary">
                    <el-button type="primary" @click="bindingOpen">绑定</el-button>
                    <!-- <el-button type="primary" @click="submitForm('ruleForm')"
                      >绑定</el-button
                    > -->
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    getBindingExchange,
    sendBinding,
    getPersonalPermission,
    sendPersonalPermission,
  } from '@/api/apiKey.js';
  export default {
    data() {
      return {
        exchange: 'bybit',
        exchangeName: '',
        apiForm: {
          exchange: {
            id: 1,
            name: 'binance',
          },
          exchangeName: '',
          key: '',
          secret: '',
          passPhrase: '',
        },
        exchangeFrom: [],
        ifDisplay: false,
        ifDisplay2: false,
        ifDisplay3: false,
        rules: {
          key: [{ required: true, message: '请输入API Key', trigger: 'blur' }],
          secret: [
            { required: true, message: '请输入API Secret', trigger: 'blur' },
          ],
        },
        firmOfferForm: {
          allowlabel: '',
          allowProperty: 1,
          allowPropertyScale: 0,
          allowBondsLabel: '',
          allowBonds: 1,
          allowBondsScale: 0,
        },
        value: '',
        value2: '',
        value3: '',

        timeout: null,
        allowProperty: false,
      };
    },
    created() {
      this.getExchanges();
      //this.getPermissionData();
    },
    mounted() { },
    methods: {
      bindingOpen() {
        this.$confirm('请确保账户权限仅为只读权限!', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          customClass: 'apiConfirm',
        })
          .then(() => {
            this.submitForm('ruleForm');
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消更新',
            });
          });
      },
      exchangeChange() { },
      //获取所有交易所信息
      async getExchanges() {
        const { data: res } = await getBindingExchange();
        this.exchangeFrom = res.data;
      },
      //绑定交易所api
      async submitForm(formName) {
        let bindingObj = {
          id: this.apiForm.exchange.id,
          apiKey: this.apiForm.key,
          secretKey: this.apiForm.secret,
          passPhrase: this.apiForm.passPhrase,
        };
        //console.log(bindingObj);
        const { data: res } = await sendBinding(bindingObj);
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$message(res.msg);
          }
        });
      },

      //点击跳转已绑定实盘
      bindingClick() {
        this.$router.push('/FirmManagement');
      },
      //跳转绑定API Key教程
      courseClick() {
        //this.$router.push('/Course');
      },
    },
  };
</script>
<style lang="scss" scope>
  .all-l {
    width: 1200px;
    margin: 40px auto !important;
    height: 100%;
    //text-align: center;
    margin-top: 40px;
    display: flex;
    flex-direction: column;

    .Breadcrumb {
      .el-breadcrumb {
        .el-breadcrumb__item {
          .el-breadcrumb__inner {
            color: rgba(209, 212, 220, 1);
            font-size: 14px;
            font-family: MicrosoftYaHei;
            line-height: 22px;
          }

          .el-breadcrumb__separator {
            font-size: 10px;
          }
        }

        .is-l {
          span {
            color: rgba(140, 140, 140, 1) !important;
          }
        }
      }
    }

    .binding-bnt {
      display: flex;
      justify-content: flex-end;
      height: 100%;

      .el-button {
        width: 102px;
        height: 32px;
        background: rgba(51, 53, 62, 1);
        border-radius: 4px;
        border: 1px solid rgba(255, 255, 255, 0.2) !important;
        line-height: 32px;
        padding: 0 !important;
        border: none;

        span {
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: rgba(209, 212, 220, 1);
          line-height: 32px;
        }
      }
    }

    .total-list {
      width: 100%;
      height: 100%;
      margin-top: 20px !important;

      .total-list-mg {
        background: rgba(159, 159, 159, 0.1);
        border-radius: 8px;
        width: 100%;
        height: 100%;
        margin-bottom: 32px;

        .exchange-api {
          padding: 24px 40px 24px 40px;

          .box-tittle {
            font-size: 20px;
            font-family: Roboto-Bold, Roboto;
            font-weight: bold;
            color: #d1d4dc;
            line-height: 24px;
          }

          .box-body {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-top: 20px;

            .el-form {
              display: flex;
              justify-content: space-between;
              width: 100%;

              .exchange-select {
                width: 200px;
                height: 358px;
                background: #33353e;
                border-radius: 8px;
                margin-right: 20px;

                .el-form-item {
                  .el-form-item__label {
                    font-size: 16px;
                    font-family: Roboto-Regular, Roboto;
                    font-weight: 400;
                    color: #d1d4dc;
                    line-height: 19px;
                    text-align: left;
                    margin: 24px 0 12px 20px;
                  }
                }

                .exchange-bnt {
                  display: flex;
                  flex-direction: column;

                  .el-form-item__content {
                    display: flex;
                    flex-direction: column;
                    margin-top: 0 !important;

                    .el-button {
                      width: 160px;
                      height: 48px;
                      background: rgba(255, 255, 255, 0.1);
                      border-radius: 4px;
                      border: none;
                      padding: 0;
                      margin: 8px 0 0 20px;
                      text-align: left;

                      span {
                        line-height: 48px;
                        display: flex;

                        .im {
                          margin: 0 8px 0 20px;

                          img {
                            margin-top: 14px;
                          }
                        }
                      }
                    }

                    .el-radio-group {
                      .el-radio-button {
                        width: 160px !important;
                        height: 48px;
                        background: rgba(255, 255, 255, 0.1);
                        border-radius: 4px;
                        border: none;
                        padding: 0;
                        margin: 8px 0 0 20px;
                        text-align: left;

                        .el-radio-button__inner {
                          padding: 0 0 !important;
                          width: 160px !important;
                          height: 48px;
                          background: rgba(255, 255, 255, 0.1);
                          -webkit-box-shadow: -1px 0 0 0 rgba(255, 255, 255, 0.1);
                          border-radius: 4px;
                          border: none;
                          font-size: 18px;
                          font-family: Roboto-Regular, Roboto;
                          font-weight: 400;
                          color: #d1d4dc;
                          line-height: 48px;
                        }

                        .el-radio-button__inner:focus {
                          //background: rgba(237, 189, 136, 0.1);
                          border-radius: 4px;
                          border: 1px solid #edbd88;
                        }

                        .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                          background: rgba(237, 189, 136, 0.1);
                          border-radius: 4px;
                          border: 1px solid #edbd88;
                        }

                        span {
                          line-height: 48px;
                          display: flex;
                          padding: 0 1;

                          .im {
                            margin: 0 8px 0 20px;

                            img {
                              margin-top: 14px;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }

              .fill-in-api {
                width: 900px;
                height: 358px;
                background: #33353e;
                border-radius: 8px;
                display: flex;
                flex-direction: column;

                .set-up {
                  display: flex;
                  justify-content: space-between;
                  height: 22px;
                  padding: 24px 20px;

                  span {
                    font-size: 16px;
                    font-family: Roboto-Regular, Roboto;
                    font-weight: 400;
                    color: #d1d4dc;
                    line-height: 19px;
                  }

                  .el-button {
                    margin: 0;
                    padding: 0;

                    span {
                      font-size: 12px;
                      font-family: DIN-Regular, DIN;
                      font-weight: 400;
                      color: #edbd88;
                      line-height: 19px;
                    }
                  }

                  a {
                    font-size: 12px;
                    font-family: DIN-Regular, DIN;
                    font-weight: 400;
                    color: #edbd88;
                    line-height: 19px;
                    text-decoration: none;
                  }
                }

                .el-form-item {
                  margin: 0 20px 32px 20px;

                  .el-form-item__label {
                    font-size: 14px;
                    font-family: Roboto-Regular, Roboto;
                    font-weight: 400;
                    color: #d1d4dc;
                    line-height: 16px;
                  }

                  .el-form-item__content {
                    .el-input {
                      margin-top: 12px;

                      .el-input__inner {
                        width: 860px;
                        height: 40px;
                        background: rgba(255, 255, 255, 0.1);
                        border-radius: 4px;
                        border: none;
                        color: #d1d4dc;
                      }

                      .el-input__inner::placeholder {
                        color: rgba(209, 212, 220, 0.6);
                      }

                      .el-input__inner:focus {
                        border: 1px solid #edbd88 !important;
                      }
                    }
                  }
                }
              }

              .primary {
                margin-top: 24px;
                text-align: right;
                margin-bottom: 0 !important;

                .el-form-item__content {
                  .el-button {
                    width: 72px;
                    height: 32px;
                    background: #edbd88;
                    border-radius: 4px;
                    border: none;
                    line-height: 32px;
                    padding: 0;

                    span {
                      font-size: 14px;
                      font-family: MicrosoftYaHei;
                      color: #33353e;
                    }
                  }
                }
              }
            }
          }

          .box-body-select {
            margin-top: 20px;

            .el-form {
              .el-form-item {
                height: 32px;
                line-height: 32px;
                margin-bottom: 8px;

                .el-form-item__label {
                  font-size: 14px;
                  font-family: MicrosoftYaHei;
                  color: #ffffff;
                  height: 32px;
                  line-height: 32px;
                }

                .el-form-item__content {
                  height: 32px;
                  line-height: 32px;

                  .el-radio-group {
                    .el-radio {
                      .el-radio__input {
                        .el-radio__inner {}
                      }

                      .el-radio__input.is-checked .el-radio__inner {
                        border: 1px solid #edbd88;
                        background: transparent;
                      }

                      .el-radio__inner::after {
                        width: 8px;
                        height: 8px;
                        border-radius: 100%;
                        background-color: #edbd88;
                      }

                      .el-radio__inner:hover {
                        border-color: #edbd88;
                      }

                      .el-radio__label {
                        font-size: 14px;
                        font-family: MicrosoftYaHei;
                        color: rgba(255, 255, 255, 0.65);
                      }
                    }

                    .el-select {
                      .el-input {
                        .el-input__inner {
                          height: 32px !important;
                          background: rgba(159, 159, 159, 0.1) !important;
                          border-radius: 4px !important;
                          border: 1px solid rgba(209, 212, 220, 0.5) !important;
                          font-size: 14px;
                          font-family: Roboto-Regular, Roboto;
                          font-weight: 400;
                          color: rgba(255, 255, 255, 0.65);
                        }
                      }
                    }
                  }
                }
              }

              .primary {
                margin-bottom: 0 !important;
                margin-top: 24px;
                text-align: right;

                .el-form-item__content {
                  .el-button {
                    width: 72px;
                    height: 32px;
                    background: #edbd88;
                    border-radius: 4px;
                    border: none;
                    line-height: 32px;
                    padding: 0;

                    span {
                      font-size: 14px;
                      font-family: MicrosoftYaHei;
                      color: #33353e;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>
<style lang="scss">
  .el-message-box__wrapper {
    .apiConfirm {
      width: 300px !important;
      height: 155px !important;

      .el-message-box__btns {
        padding: 25px 26px 16px 15px !important;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/firmOffer/NewlyIncreased.vue